import React from "react";
import { CloudPremisePluginMenu, useAuthProvider } from "@cloudpremise/portal_core";
import { useMsal } from "@azure/msal-react";
import LogoutIcon from '@mui/icons-material/Logout';

const userMenus = (): CloudPremisePluginMenu[] => {
    const { instance } = useMsal();
    const [ authorized, authType ] = useAuthProvider();
    return [
        {
            name: "Logout",
            key: "logout",
            route: "/auth/logout",
            privacy: "private",
            icon: <LogoutIcon />,
            onClick: (e) => {
                if(authType !== "microsoft"){
                    return;
                }
                e.preventDefault();
                localStorage.removeItem("reactforce_logout");
                localStorage.removeItem("identity_token");
                localStorage.removeItem("verified_entity");
                localStorage.removeItem("login_type");
                instance.logoutPopup({
                    account: instance.getActiveAccount(),
                }).catch(e => {
                    console.log(e);
                });
            }
        }
    ];
};

export default userMenus;